import type { FunctionComponent } from 'react';
import { Text } from '@kanda-libs/ks-design-library';
import { Widget } from '@kanda-libs/ks-component-ts';

import { PROPS } from './constants';

const PersonalInformation: FunctionComponent = function () {
  return (
    <>
      <Text {...PROPS.title} />
      <Text {...PROPS.description} />

      <div className="flex flex-row flex-wrap">
        <div className="min-w-60 md:min-w-50">
          <Widget.CreditCustomerDetailsGender {...PROPS.gender} />
        </div>
        <div className="flex flex-row">
          <div className="max-w-44">
            <Widget.CreditCustomerDetailsMaritalStatus
              {...PROPS.maritalStatus}
            />
          </div>
          <div className="max-w-28 ml-4">
            <Widget.CreditCustomerDetailsNumberOfDependants
              {...PROPS.numberOfDependents}
            />
          </div>
        </div>
      </div>
      <div className="max-w-52">
        <Widget.CreditCustomerDetailsTelephone {...PROPS.phoneNumber} />
      </div>
    </>
  );
};

export default PersonalInformation;
